import React from "react";
import { Line } from "@ant-design/charts";
import { Skeleton } from "@pankod/refine-antd";
import { useCustom } from "@pankod/refine-core";
import ENV from "utils/env";
import { extractArray } from "../utils";

const LABEL_MAP: Record<string, string> = {
  "product-click": "Ürün Tıklama",
  "5g-modal-open": "5G Modal",
  "5g-compatibility-check": "5G Uyumluluk",
  "5g-product-click": "5G Ürün Tıklama",
  "category-view": "Kategori",
  search: "Arama",
  "compare-add": "Karşılaştırma",
};

const COLORS = [
  "#459cd3",
  "#FFC900",
  "#448ab7",
  "#18619c",
  "#66bb6a",
  "#ef5350",
  "#ab47bc",
];

interface DailyTrendLineProps {
  dateRange: [string, string];
  shopCode: string | null;
}

export const DailyTrendLine: React.FC<DailyTrendLineProps> = ({
  dateRange,
  shopCode,
}) => {
  const { data: response, isFetching } = useCustom({
    url: `${ENV.API_URL}/api/analytics/stats/daily-trend`,
    method: "get",
    config: {
      query: {
        startDate: dateRange[0],
        endDate: dateRange[1],
        ...(shopCode ? { shopCode } : {}),
      },
    },
    queryOptions: { retry: 0 },
  });

  if (isFetching) return <Skeleton active />;

  const raw = extractArray<{ date: string; eventType: string; count: string }>(response?.data);
  const data = raw.map((r) => ({
    date: r.date,
    eventType: LABEL_MAP[r.eventType] || r.eventType,
    count: parseInt(r.count, 10),
  }));

  if (data.length === 0) {
    return (
      <span style={{ color: "#8c8c8c" }}>Bu filtrelere ait veri bulunamadı.</span>
    );
  }

  const config = {
    data,
    xField: "date",
    yField: "count",
    colorField: "eventType",
    color: COLORS,
    point: {
      shapeField: "square",
      sizeField: 4,
    },
    interaction: {
      tooltip: {
        marker: false,
      },
    },
    style: {
      lineWidth: 2,
    },
  };

  return <Line {...config} />;
};
